import { render } from "./nasaha_list.vue?vue&type=template&id=07d0d762"
import script from "./nasaha_list.vue?vue&type=script&lang=js"
export * from "./nasaha_list.vue?vue&type=script&lang=js"
script.render = render

export default script